/*
  Contagem dos numeros da faixa de prova (sections/apps.liquid): quando o numero entra na tela, conta de 1 ate o
  valor final em ~1s e termina mostrando o texto original (ex.: "+9 mil", com o "+" aparecendo no fim).
  Sem JavaScript ou com movimento reduzido, o valor final aparece direto. O leitor de tela le o valor final
  (span .sr-only no HTML); o numero animado fica com aria-hidden.
*/
(() => {
  const elements = document.querySelectorAll('[data-unend-countup]');
  if (!elements.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  const DURATION = 1000;

  const parse = (text) => {
    const match = text.match(/^(\D*?)(\d[\d.]*)(.*)$/);
    if (!match) return null;
    const hasThousands = match[2].includes('.');
    const target = parseInt(match[2].replace(/\./g, ''), 10);
    if (!Number.isFinite(target) || target < 2) return null;
    return {
      target,
      suffix: match[3],
      format: (value) => (hasThousands ? value.toLocaleString('pt-BR') : String(value))
    };
  };

  const run = (el, data, finalText) => {
    const start = performance.now();
    el.style.opacity = '1';

    const step = (now) => {
      const progress = Math.min(1, (now - start) / DURATION);
      const eased = 1 - Math.pow(1 - progress, 2);
      if (progress < 1) {
        const value = Math.max(1, Math.round(eased * data.target));
        el.textContent = data.format(value) + data.suffix;
        requestAnimationFrame(step);
      } else {
        el.textContent = finalText;
        el.style.minWidth = '';
      }
    };

    requestAnimationFrame(step);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      const el = entry.target;
      run(el, el._unendCountup.data, el._unendCountup.finalText);
    });
  }, { threshold: 0.4 });

  elements.forEach((el) => {
    const finalText = el.textContent.trim();
    const data = parse(finalText);
    if (!data) return;

    el._unendCountup = { data, finalText };
    el.style.display = 'inline-block';
    el.style.minWidth = `${el.getBoundingClientRect().width}px`;
    el.style.opacity = '0';
    el.style.transition = 'opacity 0.2s ease';
    observer.observe(el);
  });
})();
